import { render, staticRenderFns } from "./TaxSetupEditor.vue?vue&type=template&id=30d6c5e4&scoped=true&"
import script from "./TaxSetupEditor.vue?vue&type=script&lang=js&"
export * from "./TaxSetupEditor.vue?vue&type=script&lang=js&"
import style0 from "./TaxSetupEditor.vue?vue&type=style&index=0&id=30d6c5e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d6c5e4",
  null
  
)

export default component.exports